<div class="wrapper-themes">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <a routerLink="/dashboard/themes" class="btn btn-back" [attr.aria-label]="'Back' | translate">
            <i class="fi-rr-arrow-alt-left"></i>
          </a>
          <div class="title" [attr.data-parent]="'Themes' | translate">{{ themeName | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="section-main">
    <div class="theme-detail">
      <!-- The preview is a full-page screenshot: it scrolls inside its frame. -->
      <div class="theme-preview">
        <img [src]="previewImage" [alt]="themeName" />
      </div>

      <aside class="theme-panel">
        <p class="theme-panel-text" *ngIf="themeselectId !== 6">
          {{ "A sharp, minimalist design that puts your products front and center" | translate }}
        </p>
        <p class="theme-panel-text" *ngIf="themeselectId === 6">
          {{
            "A fusion of sophistication and wellness, the 'Nourish Delight' theme is meticulously designed for brands emphasizing health and luxury. Its vibrant visuals and elegant layouts amplify your product's essence, offering a seamless experience to your customers. Choose 'Nourish Delight' and let your brand's commitment to quality shine!"
              | translate
          }}
        </p>

        <div class="theme-panel-label">{{ "Great for" | translate }}</div>
        <ul class="theme-panel-list">
          <li><i class="fi fi-rr-shopping-cart"></i>{{ "Health & Beauty" | translate }}</li>
          <li *ngIf="themeselectId !== 6">
            <i class="fi fi-rr-social-network"></i>{{ "High-volume stores, Flash sales" | translate }}
          </li>
          <li *ngIf="themeselectId === 6">
            <i class="fi fi-rr-social-network"></i>{{ "High conversion, Minimalist, Content centric" | translate }}
          </li>
        </ul>

        <button
          class="btn btn-primary btn-apply"
          [disabled]="toastSuccess || isCurrentTheme || catalogLocked"
          (click)="selectThemePreset()"
        >
          <i class="fi fi-rr-check" *ngIf="toastSuccess || isCurrentTheme"></i>
          {{ (toastSuccess ? "Applied" : isCurrentTheme ? "Current theme" : "Apply Theme") | translate }}
        </button>
        <div class="theme-panel-note" *ngIf="catalogLocked">
          {{ "Available to company stores only." | translate }}
        </div>
      </aside>
    </div>
  </div>
</div>
